import { getStoredVisitorCode } from "./getStoredVisitorCode";
export const getStoredKameleoonConsent = () => {
    var _a, _b;
    try {
        const visitorCode = getStoredVisitorCode();
        if (!visitorCode)
            return null;
        const raw = localStorage.getItem("kameleoonConsentData");
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        return (_b = (_a = parsed === null || parsed === void 0 ? void 0 : parsed[visitorCode]) === null || _a === void 0 ? void 0 : _a.consent) !== null && _b !== void 0 ? _b : null;
    }
    catch (err) {
        console.warn("[Kameleoon] Failed to get active visitor consent:", err);
        return null;
    }
};
